export default __webpack_public_path__ + "static/media/poetry.f89d6e32.png";